exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cancel-container-1VRb7 {\n  margin: 0px auto;\n  padding: 30px 0px 30px 0px;\n  max-width: var(--max-content-width);\n  max-width: var(--max-content-width);\n}\n\n.Cancel-space4-2eCc2 {\n  margin-top: 24px;\n}\n\n@media screen and (max-width: 1199px) {\n  .Cancel-container-1VRb7 {\n    padding: 100px 0px 30px 0px;\n    margin: 0px auto 0px auto;\n  }\n}", ""]);

// exports
exports.locals = {
	"container": "Cancel-container-1VRb7",
	"space4": "Cancel-space4-2eCc2"
};